import { render, staticRenderFns } from "./UnidadesMedida.vue?vue&type=template&id=65b77083&"
import script from "./UnidadesMedida.vue?vue&type=script&lang=js&"
export * from "./UnidadesMedida.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports